module.exports = __webpack_public_path__ + "img/lg_ring_g_e_0_null@3x.f6f97746.png";